import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld';
import Index from '@/components/content/index/index';
import MyMission from '@/components/content/MyMission';
import MyMissionList from '@/components/content/MyMissionList';
import MyReward from '@/components/content/MyReward';
import MyMissionDetail from '@/components/content/MyMissionDetail';
import MyMissionRule from '@/components/content/MyMissionRule';
import textsss from '@/components/content/textsss';
import AppMissionDetail from '@/components/App/App_mission_detail';
import AppGuobaoDetail from '@/components/App/App_guobao_detail';
import ChineseSystem from '@/components/App/Chinese_system';
import KonwUs from '@/components/App/Konw_Us';
import HotColumn from '@/components/App/Hot_Column';
import card from "@/components/content/card";


Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index
    },{
      path: '/MyMission',
      name: 'MyMission',
      component: MyMission
    },{
      path: '/MyMissionList',
      name: 'MyMissionList',
      component: MyMissionList
    }, {
      path: '/MyReward',
      name: 'MyReward',
      component: MyReward
    }, {
      path: '/MyMissionDetail',
      name: 'MyMissionDetail',
      component: MyMissionDetail
    }, {
      path: '/MyMissionRule',
      name: 'MyMissionRule',
      component: MyMissionRule
    } ,{
      path: '/AppMissionDetail',
      name: 'AppMissionDetail',
      component: AppMissionDetail
    }, {
      path: '/AppGuobaoDetail',
      name: 'AppGuobaoDetail',
      component: AppGuobaoDetail
    }, {
      path: '/ChineseSystem',
      name: 'ChineseSystem',
      component: ChineseSystem
    }, {
      path: '/KonwUs',
      name: 'KonwUs',
      component: KonwUs
    }, {
      path: '/HotColumn',
      name: 'HotColumn',
      component: HotColumn
    },
    {
      path: '/textsss',
      name: 'textsss',
      component: textsss
    },
    {
      path: '/card',
      name: 'card',
      component: card
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js